import { useRef } from "react";
import {
  AlertDialog,
  AlertDialogOverlay,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogBody,
  AlertDialogFooter,
  Button,
  useToast,
} from "@chakra-ui/react";
import { apiErrorMessage } from "../../../shared/api/apiErrorMessage";
import { isPlanoBloqueado } from "../../../shared/api/planoBloqueado";
import { useDeleteCalendarEventMutation } from "../hooks/calendarEventQueries";
import { eventLabel, eventPeriod } from "../utils/calendarEventKinds";

// Excluir apaga o compromisso de vez (não é dado financeiro, não há histórico).
export default function DeleteCalendarEventDialog({ isOpen, onClose, event }) {
  const toast = useToast();
  const cancelRef = useRef(null);
  const mutation = useDeleteCalendarEventMutation();

  const confirm = () => {
    mutation.mutate(event.id, {
      onSuccess: () => {
        toast({ title: "Compromisso excluído", status: "success", duration: 4000 });
        onClose();
      },
      onError: (error) => {
        if (isPlanoBloqueado(error)) return;
        toast({
          title: "Não foi possível excluir o compromisso",
          description: apiErrorMessage(error),
          status: "error",
          duration: 5000,
          isClosable: true,
        });
      },
    });
  };

  return (
    <AlertDialog isOpen={isOpen} leastDestructiveRef={cancelRef} onClose={onClose} isCentered>
      <AlertDialogOverlay>
        <AlertDialogContent>
          <AlertDialogHeader fontSize="lg" fontWeight="semibold">
            Excluir compromisso?
          </AlertDialogHeader>
          <AlertDialogBody>{event ? `${eventLabel(event)} ${eventPeriod(event)} será removido do calendário.` : null}</AlertDialogBody>
          <AlertDialogFooter gap={3}>
            <Button ref={cancelRef} variant="ghost" onClick={onClose} isDisabled={mutation.isPending}>
              Voltar
            </Button>
            {/* O variant solid do tema sempre pinta brand.500 (ignora colorScheme): a cor
                destrutiva vai explícita, como no CancelShiftDialog. */}
            <Button
              bg="danger.500"
              color="white"
              _hover={{ bg: "danger.600" }}
              _active={{ bg: "danger.700" }}
              onClick={confirm}
              isLoading={mutation.isPending}
            >
              Excluir
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  );
}
